export class ErrorWrapper {
    description: string;
    error: any;
    showNavigateToMainPage: boolean;
}